import { render, staticRenderFns } from "./TipoPago.vue?vue&type=template&id=aadd54d0&"
import script from "./TipoPago.vue?vue&type=script&lang=js&"
export * from "./TipoPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports